"use client"

import React from "react"

import { useMemo } from "react"
import { useState, useEffect, useRef } from "react"
import { DataGrid } from "@mui/x-data-grid"
import {
  IconButton,
  Typography,
  Box,
  Paper,
  Button,
  Autocomplete,
  TextField,
  InputAdornment,
  Tooltip,
  Chip,
  alpha,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Snackbar,
} from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"

// Icons
import VisibilityIcon from "@mui/icons-material/Visibility"
import ReplayIcon from "@mui/icons-material/Replay"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import SearchIcon from "@mui/icons-material/Search"
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import PersonIcon from "@mui/icons-material/Person"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PointOfSaleIcon from "@mui/icons-material/PointOfSale"
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import HomeIcon from "@mui/icons-material/Home"
import PaymentIcon from "@mui/icons-material/Payment"
import CheckIcon from "@mui/icons-material/Check"
import ErrorIcon from "@mui/icons-material/Error"

import { ThemeProvider, createTheme } from "@mui/material/styles"
import { GridFooterContainer, GridFooter } from "@mui/x-data-grid"

import dayjs from "dayjs"

// Datos ficticios hardcodeados - 20 casos (ahora mutable)
const mockOrdersData = [
  {
    id: 1001,
    createdAt: "15/07/2025 10:30",
    montoTotal: 25000,
    descripcionEntidad: "Juan Pérez",
    apellido: "González",
    dniCuitCuil: "12345678",
    direccion: "Av. Corrientes 1234, CABA",
    estado: "pendiente",
    usuario: "María García",
    ubicacion: "Sucursal Centro",
    medioPago: "Sin definir",
    fechaHoraCreacion: "2025-07-15T10:30:00",
    fechaActualizacion: "2025-07-15T10:30:00",
    items: [{ codigo: "PROD001", descripcion: "Notebook Lenovo", cantidad: 1, precio: 25000 }],
  },
  {
    id: 1002,
    createdAt: "15/07/2025 11:45",
    montoTotal: 15500,
    descripcionEntidad: "Ana Rodríguez",
    apellido: "Silva",
    dniCuitCuil: "87654321",
    direccion: "Calle Falsa 123, Palermo",
    estado: "recibido",
    usuario: "Carlos López",
    ubicacion: "Sucursal Norte",
    medioPago: "Efectivo",
    fechaHoraCreacion: "2025-07-15T11:45:00",
    fechaActualizacion: "2025-07-15T11:45:00",
    items: [
      { codigo: "PROD002", descripcion: "Mouse Inalámbrico", cantidad: 2, precio: 2500 },
      { codigo: "PROD003", descripcion: "Teclado Mecánico", cantidad: 1, precio: 10500 },
    ],
  },
  {
    id: 1003,
    createdAt: "14/07/2025 16:20",
    montoTotal: 45000,
    descripcionEntidad: "Roberto Silva",
    apellido: "Martínez",
    dniCuitCuil: "11223344",
    direccion: "San Martín 567, Belgrano",
    estado: "despachado",
    usuario: "Laura Martínez",
    ubicacion: "Sucursal Sur",
    medioPago: "Transferencia",
    fechaHoraCreacion: "2025-07-14T16:20:00",
    fechaActualizacion: "2025-07-14T16:20:00",
    items: [
      { codigo: "PROD004", descripcion: "Monitor 24 pulgadas", cantidad: 1, precio: 35000 },
      { codigo: "PROD005", descripcion: "Webcam HD", cantidad: 1, precio: 10000 },
    ],
  },
  {
    id: 1004,
    createdAt: "13/07/2025 09:15",
    montoTotal: 8500,
    descripcionEntidad: "Sofía González",
    apellido: "Torres",
    dniCuitCuil: "55667788",
    direccion: "Rivadavia 890, Caballito",
    estado: "entregado",
    usuario: "Diego Fernández",
    ubicacion: "Sucursal Centro",
    medioPago: "Débito",
    fechaHoraCreacion: "2025-07-13T09:15:00",
    fechaActualizacion: "2025-07-13T09:15:00",
    items: [{ codigo: "PROD006", descripcion: "Auriculares Bluetooth", cantidad: 1, precio: 8500 }],
  },
  {
    id: 1005,
    createdAt: "15/07/2025 14:30",
    montoTotal: 32000,
    descripcionEntidad: "Miguel Torres",
    apellido: "Vega",
    dniCuitCuil: "99887766",
    direccion: "Libertador 2345, Núñez",
    estado: "pendiente",
    usuario: "Patricia Ruiz",
    ubicacion: "Sucursal Norte",
    medioPago: "Sin definir",
    fechaHoraCreacion: "2025-07-15T14:30:00",
    fechaActualizacion: "2025-07-15T14:30:00",
    items: [{ codigo: "PROD007", descripcion: "Tablet Samsung", cantidad: 1, precio: 32000 }],
  },
  {
    id: 1006,
    createdAt: "14/07/2025 12:00",
    montoTotal: 18000,
    descripcionEntidad: "Carmen Vega",
    apellido: "Castro",
    dniCuitCuil: "44556677",
    direccion: "Avenida Santa Fe 1567, Recoleta",
    estado: "recibido",
    usuario: "Andrés Castro",
    ubicacion: "Sucursal Centro",
    medioPago: "Efectivo",
    fechaHoraCreacion: "2025-07-14T12:00:00",
    fechaActualizacion: "2025-07-14T12:00:00",
    items: [{ codigo: "PROD008", descripcion: "Impresora Multifunción", cantidad: 1, precio: 18000 }],
  },
  {
    id: 1007,
    createdAt: "16/07/2025 09:30",
    montoTotal: 12000,
    descripcionEntidad: "Luis Morales",
    apellido: "Díaz",
    dniCuitCuil: "33445566",
    direccion: "Av. Cabildo 2890, Belgrano",
    estado: "pendiente",
    usuario: "Fernanda López",
    ubicacion: "Sucursal Norte",
    medioPago: "Sin definir",
    fechaHoraCreacion: "2025-07-16T09:30:00",
    fechaActualizacion: "2025-07-16T09:30:00",
    items: [{ codigo: "PROD009", descripcion: "Smartphone Samsung", cantidad: 1, precio: 12000 }],
  },
  {
    id: 1008,
    createdAt: "16/07/2025 15:45",
    montoTotal: 28000,
    descripcionEntidad: "Elena Vargas",
    apellido: "Ruiz",
    dniCuitCuil: "77889900",
    direccion: "Callao 1456, Barrio Norte",
    estado: "despachado",
    usuario: "Roberto Sánchez",
    ubicacion: "Sucursal Centro",
    medioPago: "Tarjeta de Crédito",
    fechaHoraCreacion: "2025-07-16T15:45:00",
    fechaActualizacion: "2025-07-16T15:45:00",
    items: [{ codigo: "PROD010", descripcion: "Laptop HP", cantidad: 1, precio: 28000 }],
  },
  {
    id: 1009,
    createdAt: "12/07/2025 11:20",
    montoTotal: 5500,
    descripcionEntidad: "Pedro Ramírez",
    apellido: "Jiménez",
    dniCuitCuil: "11998877",
    direccion: "Maipú 567, Microcentro",
    estado: "entregado",
    usuario: "Ana Martín",
    ubicacion: "Sucursal Centro",
    medioPago: "Transferencia",
    fechaHoraCreacion: "2025-07-12T11:20:00",
    fechaActualizacion: "2025-07-12T11:20:00",
    items: [{ codigo: "PROD011", descripcion: "Cargador Universal", cantidad: 3, precio: 1833 }],
  },
  {
    id: 1010,
    createdAt: "17/07/2025 13:15",
    montoTotal: 39000,
    descripcionEntidad: "Claudia Herrera",
    apellido: "Mendoza",
    dniCuitCuil: "22334455",
    direccion: "Av. Las Heras 3456, Recoleta",
    estado: "despachado",
    usuario: "Javier Pérez",
    ubicacion: "Sucursal Norte",
    medioPago: "Débito",
    fechaHoraCreacion: "2025-07-17T13:15:00",
    fechaActualizacion: "2025-07-17T13:15:00",
    items: [{ codigo: "PROD012", descripcion: "Smart TV 43 pulgadas", cantidad: 1, precio: 39000 }],
  },
  {
    id: 1011,
    createdAt: "11/07/2025 16:30",
    montoTotal: 7200,
    descripcionEntidad: "Fernando Castro",
    apellido: "Moreno",
    dniCuitCuil: "66778899",
    direccion: "Defensa 890, San Telmo",
    estado: "entregado",
    usuario: "Lucía Fernández",
    ubicacion: "Sucursal Sur",
    medioPago: "Efectivo",
    fechaHoraCreacion: "2025-07-11T16:30:00",
    fechaActualizacion: "2025-07-11T16:30:00",
    items: [{ codigo: "PROD013", descripcion: "Parlante Bluetooth", cantidad: 2, precio: 3600 }],
  },
  {
    id: 1012,
    createdAt: "18/07/2025 10:45",
    montoTotal: 21000,
    descripcionEntidad: "Gabriela Soto",
    apellido: "Álvarez",
    dniCuitCuil: "44556677",
    direccion: "Scalabrini Ortiz 1234, Palermo",
    estado: "pendiente",
    usuario: "Martín González",
    ubicacion: "Sucursal Norte",
    medioPago: "Sin definir",
    fechaHoraCreacion: "2025-07-18T10:45:00",
    fechaActualizacion: "2025-07-18T10:45:00",
    items: [{ codigo: "PROD014", descripcion: "Aire Acondicionado", cantidad: 1, precio: 21000 }],
  },
  {
    id: 1013,
    createdAt: "10/07/2025 14:20",
    montoTotal: 16800,
    descripcionEntidad: "Ricardo Blanco",
    apellido: "Navarro",
    dniCuitCuil: "88990011",
    direccion: "Av. Córdoba 2345, Balvanera",
    estado: "entregado",
    usuario: "Valeria Ruiz",
    ubicacion: "Sucursal Centro",
    medioPago: "Transferencia",
    fechaHoraCreacion: "2025-07-10T14:20:00",
    fechaActualizacion: "2025-07-10T14:20:00",
    items: [{ codigo: "PROD015", descripcion: "Microondas", cantidad: 1, precio: 16800 }],
  },
  {
    id: 1014,
    createdAt: "19/07/2025 12:30",
    montoTotal: 9500,
    descripcionEntidad: "Mónica Delgado",
    apellido: "Romero",
    dniCuitCuil: "55443322",
    direccion: "Juncal 1890, Retiro",
    estado: "recibido",
    usuario: "Sebastián Torres",
    ubicacion: "Sucursal Centro",
    medioPago: "Débito",
    fechaHoraCreacion: "2025-07-19T12:30:00",
    fechaActualizacion: "2025-07-19T12:30:00",
    items: [{ codigo: "PROD016", descripcion: "Cafetera Express", cantidad: 1, precio: 9500 }],
  },
  {
    id: 1015,
    createdAt: "09/07/2025 17:45",
    montoTotal: 13500,
    descripcionEntidad: "Alejandro Paz",
    apellido: "Guerrero",
    dniCuitCuil: "77665544",
    direccion: "Av. Rivadavia 5678, Caballito",
    estado: "entregado",
    usuario: "Carolina Vega",
    ubicacion: "Sucursal Sur",
    medioPago: "Efectivo",
    fechaHoraCreacion: "2025-07-09T17:45:00",
    fechaActualizacion: "2025-07-09T17:45:00",
    items: [{ codigo: "PROD017", descripcion: "Aspiradora Robot", cantidad: 1, precio: 13500 }],
  },
  {
    id: 1016,
    createdAt: "20/07/2025 11:15",
    montoTotal: 4200,
    descripcionEntidad: "Natalia Campos",
    apellido: "Herrera",
    dniCuitCuil: "99887766",
    direccion: "Lavalle 987, Microcentro",
    estado: "pendiente",
    usuario: "Diego Morales",
    ubicacion: "Sucursal Centro",
    medioPago: "Sin definir",
    fechaHoraCreacion: "2025-07-20T11:15:00",
    fechaActualizacion: "2025-07-20T11:15:00",
    items: [{ codigo: "PROD018", descripcion: "Funda para Notebook", cantidad: 4, precio: 1050 }],
  },
  {
    id: 1017,
    createdAt: "08/07/2025 15:30",
    montoTotal: 31000,
    descripcionEntidad: "Andrés Molina",
    apellido: "Vargas",
    dniCuitCuil: "33221100",
    direccion: "Av. Santa Fe 4567, Palermo",
    estado: "despachado",
    usuario: "Isabel Castro",
    ubicacion: "Sucursal Norte",
    medioPago: "Transferencia",
    fechaHoraCreacion: "2025-07-08T15:30:00",
    fechaActualizacion: "2025-07-08T15:30:00",
    items: [{ codigo: "PROD019", descripcion: "Heladera", cantidad: 1, precio: 31000 }],
  },
  {
    id: 1018,
    createdAt: "21/07/2025 09:45",
    montoTotal: 6800,
    descripcionEntidad: "Verónica Luna",
    apellido: "Ortega",
    dniCuitCuil: "11223344",
    direccion: "Belgrano 2345, Monserrat",
    estado: "recibido",
    usuario: "Raúl Mendoza",
    ubicacion: "Sucursal Sur",
    medioPago: "Efectivo",
    fechaHoraCreacion: "2025-07-21T09:45:00",
    fechaActualizacion: "2025-07-21T09:45:00",
    items: [{ codigo: "PROD020", descripcion: "Plancha de Ropa", cantidad: 2, precio: 3400 }],
  },
  {
    id: 1019,
    createdAt: "07/07/2025 13:20",
    montoTotal: 24500,
    descripcionEntidad: "Gustavo Ramos",
    apellido: "Silva",
    dniCuitCuil: "66554433",
    direccion: "Av. Corrientes 6789, Almagro",
    estado: "entregado",
    usuario: "Paola Jiménez",
    ubicacion: "Sucursal Centro",
    medioPago: "Tarjeta de Crédito",
    fechaHoraCreacion: "2025-07-07T13:20:00",
    fechaActualizacion: "2025-07-07T13:20:00",
    items: [{ codigo: "PROD021", descripcion: "Lavarropas", cantidad: 1, precio: 24500 }],
  },
  {
    id: 1020,
    createdAt: "22/07/2025 16:10",
    montoTotal: 11200,
    descripcionEntidad: "Patricia Flores",
    apellido: "Medina",
    dniCuitCuil: "88776655",
    direccion: "Av. Pueyrredón 1234, Barrio Norte",
    estado: "pendiente",
    usuario: "Emilio Vargas",
    ubicacion: "Sucursal Norte",
    medioPago: "Sin definir",
    fechaHoraCreacion: "2025-07-22T16:10:00",
    fechaActualizacion: "2025-07-22T16:10:00",
    items: [{ codigo: "PROD022", descripcion: "Ventilador de Techo", cantidad: 1, precio: 11200 }],
  },
]

const ubicaciones = [
  { id: 1, descripcion: "Sucursal Centro" },
  { id: 2, descripcion: "Sucursal Norte" },
  { id: 3, descripcion: "Sucursal Sur" },
]

const entidadesClientesTresLetras = [
  { id: 1, descripcion: "Juan Pérez", apellido: "González", dniCuitCuil: "12345678" },
  { id: 2, descripcion: "Ana Rodríguez", apellido: "Silva", dniCuitCuil: "87654321" },
  { id: 3, descripcion: "Roberto Silva", apellido: "Martínez", dniCuitCuil: "11223344" },
  { id: 4, descripcion: "Sofía González", apellido: "Torres", dniCuitCuil: "55667788" },
  { id: 5, descripcion: "Miguel Torres", apellido: "Vega", dniCuitCuil: "99887766" },
  { id: 6, descripcion: "Carmen Vega", apellido: "Castro", dniCuitCuil: "44556677" },
  { id: 7, descripcion: "Luis Morales", apellido: "Díaz", dniCuitCuil: "33445566" },
  { id: 8, descripcion: "Elena Vargas", apellido: "Ruiz", dniCuitCuil: "77889900" },
  { id: 9, descripcion: "Pedro Ramírez", apellido: "Jiménez", dniCuitCuil: "11998877" },
  { id: 10, descripcion: "Claudia Herrera", apellido: "Mendoza", dniCuitCuil: "22334455" },
  { id: 11, descripcion: "Fernando Castro", apellido: "Moreno", dniCuitCuil: "66778899" },
  { id: 12, descripcion: "Gabriela Soto", apellido: "Álvarez", dniCuitCuil: "44556677" },
  { id: 13, descripcion: "Ricardo Blanco", apellido: "Navarro", dniCuitCuil: "88990011" },
  { id: 14, descripcion: "Mónica Delgado", apellido: "Romero", dniCuitCuil: "55443322" },
  { id: 15, descripcion: "Alejandro Paz", apellido: "Guerrero", dniCuitCuil: "77665544" },
  { id: 16, descripcion: "Natalia Campos", apellido: "Herrera", dniCuitCuil: "99887766" },
  { id: 17, descripcion: "Andrés Molina", apellido: "Vargas", dniCuitCuil: "33221100" },
  { id: 18, descripcion: "Verónica Luna", apellido: "Ortega", dniCuitCuil: "11223344" },
  { id: 19, descripcion: "Gustavo Ramos", apellido: "Silva", dniCuitCuil: "66554433" },
  { id: 20, descripcion: "Patricia Flores", apellido: "Medina", dniCuitCuil: "88776655" },
]

const mediosDePago = ["Efectivo", "Tarjeta de Crédito", "Tarjeta de Débito", "Transferencia", "Mercado Pago", "Cheque"]

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#5b5b5f",
    },
    secondary: {
      main: "rgb(244, 177, 14)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
})

const estadoConfig = {
  pendiente: {
    color: "#FFA726",
    bgColor: alpha("#FFA726", 0.1),
    icon: HourglassEmptyIcon,
    label: "Pendiente",
    nextStates: ["recibido"], // Solo puede pasar a recibido
  },
  recibido: {
    color: "#42A5F5",
    bgColor: alpha("#42A5F5", 0.1),
    icon: CheckCircleIcon,
    label: "Recibido",
    nextStates: ["despachado"], // Solo puede pasar a despachado
  },
  despachado: {
    color: "#FF7043",
    bgColor: alpha("#FF7043", 0.1),
    icon: LocalShippingIcon,
    label: "Despachado",
    nextStates: ["entregado"], // Solo puede pasar a entregado
  },
  entregado: {
    color: "#66BB6A",
    bgColor: alpha("#66BB6A", 0.1),
    icon: HomeIcon,
    label: "Entregado",
    nextStates: [], // Estado final
  },
}

export default function SimulacionEstados() {
  // Estados principales
  const [openModal, setOpenModal] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [rows, setRows] = useState([...mockOrdersData])
  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const today = dayjs()
  const [startDate, setStartDate] = useState(today.subtract(30, "day"))
  const [endDate, setEndDate] = useState(today)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(100)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(mockOrdersData.length)
  const [montoTotalTransacciones, setMontoTotalTransacciones] = useState(0)
  const [minVentas, setMinVentas] = useState(0)
  const [maxVentas, setMaxVentas] = useState(0)
  const [loading, setLoading] = useState(false)
  const [sortedData, setSortedData] = useState([...mockOrdersData])
  const [dniCliente, setDniCliente] = useState("")
  const [searchTextCliente, setSearchTextCliente] = useState("")
  const [filtersActive, setFiltersActive] = useState(false)
  const isFirstRender = useRef(true)
  const [mostrarDeletes, setMostrarDeletes] = useState(false)
  const [idTransaccionSearch, setIdTransaccionSearch] = useState("")
  const [estadoFilter, setEstadoFilter] = useState("")

  // Estados para modal de pago
  const [openPaymentModal, setOpenPaymentModal] = useState(false)
  const [pendingOrderId, setPendingOrderId] = useState(null)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("")

  // Estados para notificaciones
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  })

  // Funciones para manipular fechas
  const increaseDate = () => setStartDate((prev) => (prev ? prev.add(1, "day") : dayjs()))
  const decreaseDate = () => setStartDate((prev) => (prev ? prev.subtract(1, "day") : dayjs()))

  useEffect(() => {
    const total = sortedData.reduce((sum, order) => sum + order.montoTotal, 0)
    setMontoTotalTransacciones(total)
  }, [sortedData])

  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    })
  }

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false })
  }

  const handleMinChange = (e) => {
    const newMin = Number(e.target.value)
    if (newMin <= maxVentas || maxVentas === 0) {
      setMinVentas(newMin)
    }
  }

  const handleMaxChange = (e) => {
    const newMax = Number(e.target.value)
    if (newMax >= minVentas || newMax === 0) {
      setMaxVentas(newMax)
    }
  }

  const isDateInRange = (orderDate, startDate, endDate) => {
    const orderDayjs = dayjs(orderDate, "DD/MM/YYYY HH:mm")
    const start = startDate.startOf("day")
    const end = endDate.endOf("day")
    return orderDayjs.isAfter(start) && orderDayjs.isBefore(end)
  }

  const buttonFiltrado = () => {
    let filtered = [...mockOrdersData]

    // Filtro por fechas
    if (startDate && endDate) {
      filtered = filtered.filter((order) => isDateInRange(order.createdAt, startDate, endDate))
    }

    // Filtro por cliente
    if (dniCliente) {
      filtered = filtered.filter(
        (order) =>
          order.descripcionEntidad.toLowerCase().includes(dniCliente.descripcion?.toLowerCase() || "") ||
          order.dniCuitCuil.includes(dniCliente.dniCuitCuil || ""),
      )
    }

    // Filtro por ubicación
    if (selectedUbicacion) {
      filtered = filtered.filter((order) => order.ubicacion === selectedUbicacion.descripcion)
    }

    // Filtro por monto
    if (minVentas > 0) {
      filtered = filtered.filter((order) => order.montoTotal >= minVentas)
    }
    if (maxVentas > 0) {
      filtered = filtered.filter((order) => order.montoTotal <= maxVentas)
    }

    // Filtro por ID
    if (idTransaccionSearch) {
      filtered = filtered.filter((order) => order.id.toString().includes(idTransaccionSearch))
    }

    // Filtro por estado
    if (estadoFilter) {
      filtered = filtered.filter((order) => order.estado === estadoFilter)
    }

    setSortedData(filtered)
    setFiltersActive(true)
  }

  const resetFilters = () => {
    setDniCliente("")
    setSelectedUbicacion(null)
    setSearchTextCliente("")
    setMinVentas(0)
    setMaxVentas(0)
    setMostrarDeletes(false)
    setIdTransaccionSearch("")
    setEstadoFilter("")
    const today = dayjs()
    setStartDate(today.subtract(30, "day"))
    setEndDate(today)
    setSortedData([...mockOrdersData])
    setFiltersActive(false)
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
    }).format(value)
  }

  const handleOpenModal = (orderRow) => {
    setSelectedOrder(orderRow)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setSelectedOrder(null)
  }

  const canChangeToState = (currentState, newState) => {
    const config = estadoConfig[currentState]
    return config && config.nextStates.includes(newState)
  }

  const handleStatusChange = (orderId, newStatus) => {
    const order = mockOrdersData.find((o) => o.id === orderId)
    if (!order) return

    // Validar si el cambio de estado es permitido
    if (!canChangeToState(order.estado, newStatus)) {
      showNotification(
        `No se puede cambiar de "${estadoConfig[order.estado].label}" a "${estadoConfig[newStatus].label}". Debe seguir el flujo: Pendiente → Recibido → Despachado → Entregado`,
        "error",
      )
      return
    }

    // Si está cambiando de pendiente a recibido, mostrar modal de pago
    if (order.estado === "pendiente" && newStatus === "recibido") {
      setPendingOrderId(orderId)
      setOpenPaymentModal(true)
      return
    }

    // Para otros cambios de estado, proceder normalmente
    updateOrderStatus(orderId, newStatus)
  }

  const updateOrderStatus = (orderId, newStatus, newPaymentMethod = null) => {
    const now = new Date().toISOString()

    // Crear una nueva copia del array para evitar mutaciones
    const updatedOrders = mockOrdersData.map((order) => {
      if (order.id === orderId) {
        const updatedOrder = {
          ...order,
          estado: newStatus,
          fechaActualizacion: now, // Agregar esta línea
        }
        if (newPaymentMethod) {
          updatedOrder.medioPago = newPaymentMethod
        }
        return updatedOrder
      }
      return order
    })

    // Actualizar el array original
    mockOrdersData.length = 0
    mockOrdersData.push(...updatedOrders)

    // Actualizar los datos filtrados
    setSortedData((prev) =>
      prev.map((order) => {
        if (order.id === orderId) {
          const updatedOrder = {
            ...order,
            estado: newStatus,
            fechaActualizacion: now, // Agregar esta línea
          }
          if (newPaymentMethod) {
            updatedOrder.medioPago = newPaymentMethod
          }
          return updatedOrder
        }
        return order
      }),
    )

    // Actualizar el pedido seleccionado si está abierto
    if (selectedOrder && selectedOrder.id === orderId) {
      const updatedSelectedOrder = {
        ...selectedOrder,
        estado: newStatus,
        fechaActualizacion: now, // Agregar esta línea
      }
      if (newPaymentMethod) {
        updatedSelectedOrder.medioPago = newPaymentMethod
      }
      setSelectedOrder(updatedSelectedOrder)
    }

    // Mostrar notificación de éxito
    const order = updatedOrders.find((o) => o.id === orderId)
    const paymentInfo = newPaymentMethod ? ` con medio de pago: ${newPaymentMethod}` : ""
    showNotification(
      `✅ Pedido #${orderId} de ${order.descripcionEntidad} ${order.apellido} cambió a estado "${estadoConfig[newStatus].label}"${paymentInfo}`,
      "success",
    )
  }

  const handlePaymentConfirm = () => {
    if (!selectedPaymentMethod) {
      showNotification("Debe seleccionar un medio de pago", "error")
      return
    }

    updateOrderStatus(pendingOrderId, "recibido", selectedPaymentMethod)
    setOpenPaymentModal(false)
    setPendingOrderId(null)
    setSelectedPaymentMethod("")
  }

  const handlePaymentCancel = () => {
    setOpenPaymentModal(false)
    setPendingOrderId(null)
    setSelectedPaymentMethod("")
  }

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.3,
      minWidth: 70,
      headerAlign: "center",
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "createdAt",
      headerName: "Fecha",
      flex: 1,
      headerAlign: "center",
      minWidth: 200,
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
          <CalendarTodayIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "fechaActualizacion",
      headerName: "Última Actualización",
      flex: 1,
      headerAlign: "center",
      minWidth: 200,
      renderCell: (params) => {
        const fechaActualizacion = new Date(params.value).toLocaleString("es-AR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
        const isRecent = new Date() - new Date(params.value) < 300000 // 5 minutos

        return (
          <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1, alignItems: "center" }}>
            <CalendarTodayIcon
              fontSize="small"
              sx={{
                color: isRecent ? "#4CAF50" : alpha("#5b5b5f", 0.7),
                animation: isRecent ? "pulse 2s infinite" : "none",
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: isRecent ? "#4CAF50" : "inherit",
                fontWeight: isRecent ? "bold" : "normal",
              }}
            >
              {fechaActualizacion}
            </Typography>
          </Box>
        )
      },
    },
    {
      field: "montoTotal",
      headerName: "Monto",
      type: "number",
      flex: 0.8,
      minWidth: 130,
      headerAlign: "center",
      renderCell: (params) => (
        <Chip
          icon={<AttachMoneyIcon fontSize="small" />}
          label={params.value?.toLocaleString("es-AR") || "0.00"}
          size="small"
          sx={{
            fontWeight: "bold",
            bgcolor: alpha("#4CAF50", 0.1),
            color: "#4CAF50",
            "& .MuiChip-icon": {
              color: "#4CAF50",
            },
            display: "flex",
          }}
        />
      ),
    },
    {
      field: "descripcionEntidad",
      headerName: "Cliente",
      flex: 1.2,
      headerAlign: "center",
      minWidth: 150,
      renderCell: (params) => (
        <Tooltip title={`${params.row.descripcionEntidad} ${params.row.apellido || ""}`}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PersonIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
            <Typography variant="body2" noWrap fontWeight={"500"}>
              {params.row.descripcionEntidad} {params.row.apellido || ""}
            </Typography>
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "estado",
      headerName: "Estado",
      flex: 0.8,
      minWidth: 120,
      headerAlign: "center",
      renderCell: (params) => {
        const estadoInfo = estadoConfig[params.value]
        const Icon = estadoInfo.icon
        return (
          <Chip
            icon={<Icon fontSize="small" />}
            label={estadoInfo.label}
            size="small"
            sx={{
              fontWeight: "bold",
              bgcolor: estadoInfo.bgColor,
              color: estadoInfo.color,
              "& .MuiChip-icon": {
                color: estadoInfo.color,
              },
              display: "flex",
            }}
          />
        )
      },
    },
    {
      field: "medioPago",
      headerName: "Medio de Pago",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      renderCell: (params) => (
        <Chip
          icon={<PointOfSaleIcon fontSize="small" />}
          label={params.value || "N/A"}
          size="small"
          variant="outlined"
          sx={{
            fontWeight: "bold",
            color: params.value === "Sin definir" ? "#FF9800" : "#00AAE4",
            borderColor: alpha(params.value === "Sin definir" ? "#FF9800" : "#00AAE4", 0.5),
            "& .MuiChip-icon": { color: params.value === "Sin definir" ? "#FF9800" : "#00AAE4" },
            display: "flex",
          }}
        />
      ),
    },
    {
      field: "usuario",
      headerName: "Vendedor",
      flex: 0.8,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontStyle: "italic" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "ubicacion",
      headerName: "Ubicación",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LocationOnIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Acciones",
      flex: 0.8,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Tooltip title="Ver detalles">
            <IconButton
              onClick={() => handleOpenModal(params.row)}
              size="small"
              sx={{
                bgcolor: alpha("#5b5b5f", 0.1),
                "&:hover": { bgcolor: alpha("#5b5b5f", 0.2) },
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Descargar PDF">
            <IconButton
              onClick={() => console.log("Descargar PDF", params.row.id)}
              size="small"
              sx={{
                bgcolor: alpha("rgb(244, 177, 14)", 0.1),
                "&:hover": { bgcolor: alpha("rgb(244, 177, 14)", 0.2) },
              }}
            >
              <PictureAsPdfIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Descargar remito">
            <IconButton
              onClick={() => console.log("Descargar remito", params.row.id)}
              size="small"
              sx={{
                bgcolor: alpha("#4CAF50", 0.1),
                "&:hover": { bgcolor: alpha("#4CAF50", 0.2) },
              }}
            >
              <ReceiptLongIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ]

  const totalVentas = useMemo(() => sortedData.reduce((acc, row) => acc + (row.montoTotal || 0), 0), [sortedData])

  const CustomFooter = () => (
    <GridFooterContainer>
      <div
        style={{
          padding: "10px",
          fontWeight: "bold",
          fontSize: "16px",
          textAlign: "right",
          width: "100%",
          backgroundColor: "#f5f5f5",
        }}
      >
        Total Ventas: <span style={{ color: "#4CAF50" }}>${totalVentas.toLocaleString("es-AR")}</span>
      </div>
      <GridFooter />
    </GridFooterContainer>
  )

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <ThemeProvider theme={theme}>
        {/* Contenedor de filtros */}
        <Paper
          elevation={3}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.background.paper, 0.9),
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Filtro de fechas */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.2,
                flex: 1,
                minWidth: 250,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <IconButton onClick={decreaseDate} color="primary" size="small">
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
                <DatePicker
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  format="DD/MM/YYYY"
                  label="Desde"
                  slotProps={{
                    textField: { size: "small", inputProps: { maxLength: 10 } },
                  }}
                  sx={{ width: 150 }}
                />
                <DatePicker
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  format="DD/MM/YYYY"
                  label="Hasta"
                  slotProps={{
                    textField: { size: "small", inputProps: { maxLength: 10 } },
                  }}
                  sx={{ width: 150 }}
                />
                <IconButton onClick={increaseDate} color="primary" size="small">
                  <ArrowForwardIcon fontSize="small" />
                </IconButton>
              </LocalizationProvider>
            </Box>

            {/* Filtro de montos */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                flex: 1,
                minWidth: 200,
              }}
            >
              <TextField
                label="Mínimo"
                type="number"
                size="small"
                value={minVentas}
                onChange={handleMinChange}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                sx={{ width: 150 }}
              />
              <TextField
                label="Máximo"
                type="number"
                size="small"
                value={maxVentas}
                onChange={handleMaxChange}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                sx={{ width: 150 }}
              />
            </Box>

            {/* Filtro de cliente y ubicación */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flex: 2,
                minWidth: 300,
              }}
            >
              <TextField
                label="Buscar por ID"
                type="number"
                size="small"
                value={idTransaccionSearch}
                onChange={(e) => setIdTransaccionSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{ width: "20%" }}
              />
              <Autocomplete
                size="small"
                disablePortal
                options={entidadesClientesTresLetras.map((it) => ({
                  label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
                  ...it,
                }))}
                value={dniCliente}
                onChange={(event, newValue) => setDniCliente(newValue || "")}
                onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
                sx={{ flex: 1 }}
                renderInput={(params) => <TextField {...params} label="Cliente" variant="outlined" />}
              />
              <Autocomplete
                size="small"
                disablePortal
                options={ubicaciones.map((it) => ({
                  id: it.id,
                  label: it.descripcion,
                  descripcion: it.descripcion,
                }))}
                value={selectedUbicacion}
                onChange={(event, newValue) => setSelectedUbicacion(newValue)}
                sx={{ flex: 1 }}
                renderInput={(params) => <TextField {...params} label="Ubicación" variant="outlined" />}
              />
              <Autocomplete
                size="small"
                disablePortal
                options={Object.entries(estadoConfig).map(([key, config]) => ({
                  value: key,
                  label: config.label,
                }))}
                value={estadoFilter ? { value: estadoFilter, label: estadoConfig[estadoFilter].label } : null}
                onChange={(event, newValue) => setEstadoFilter(newValue?.value || "")}
                sx={{ flex: 1 }}
                renderInput={(params) => <TextField {...params} label="Estado" variant="outlined" />}
              />
            </Box>

            {/* Botones de acción */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={buttonFiltrado}
                startIcon={<SearchIcon />}
                sx={{
                  backgroundColor: "#5b5b5f",
                  textTransform: "none",
                  padding: "8px 16px",
                  color: "white",
                  "&:hover": {
                    backgroundColor: alpha("rgb(244, 177, 14)", 0.8),
                  },
                }}
              >
                Buscar
              </Button>

              <Tooltip title={filtersActive ? "Resetear filtros" : "Refrescar"}>
                <IconButton
                  onClick={resetFilters}
                  color="primary"
                  size="small"
                  sx={{
                    bgcolor: filtersActive ? alpha(theme.palette.secondary.main, 0.1) : "transparent",
                    "&:hover": {
                      bgcolor: alpha(theme.palette.secondary.main, 0.2),
                    },
                  }}
                >
                  {filtersActive ? <FilterAltOffIcon /> : <ReplayIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Paper>

        {/* Contenedor de la tabla */}
        <Paper
          sx={{
            flex: 1,
            m: 1,
            borderRadius: 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            position: "relative",
            height: "500px",
          }}
        >
          <DataGrid
            rows={sortedData}
            columns={columns}
            getRowId={(row) => row.id}
            pagination
            getRowHeight={() => 35}
            headerHeight={35}
            sx={{
              width: "100%",
              border: 0,
              "& .MuiDataGrid-footerContainer": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#5b5b5f",
                color: "white",
                borderBottom: "2px solid #333",
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "white !important",
                lineHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                color: "white !important",
              },
              "& .MuiDataGrid-menuIconButton": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiInputBase-root": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiTablePagination-root": {
                color: "black !important",
              },
              "& .MuiSelect-icon": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiDataGrid-row": {
                "&:nth-of-type(even)": {
                  backgroundColor: "#F7F7F7",
                },
                "&:hover": {
                  backgroundColor: "#E3EAFD !important",
                  transition: "background 0.3s ease",
                },
              },
              "& .MuiDataGrid-virtualScroller": {
                lineHeight: "none !important",
                height: "10px !imporant",
              },
              "& .MuiDataGrid-footerContainer": {
                position: "sticky",
                bottom: 0,
                backgroundColor: "#ffffff",
                borderTop: "1px solid #ddd",
                zIndex: 10,
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                width: "2px",
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
              "@keyframes pulse": {
                "0%": {
                  opacity: 1,
                },
                "50%": {
                  opacity: 0.5,
                },
                "100%": {
                  opacity: 1,
                },
              },
            }}
            components={{
              Pagination: () => null,
              Footer: CustomFooter,
            }}
          />
        </Paper>

        {/* Modal de detalles */}
        {openModal && selectedOrder && (
          <OrderDetailModal
            open={openModal}
            onClose={handleCloseModal}
            order={selectedOrder}
            onStatusChange={handleStatusChange}
            canChangeToState={canChangeToState}
          />
        )}

        {/* Modal de selección de medio de pago */}
        <Dialog open={openPaymentModal} onClose={handlePaymentCancel} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PaymentIcon />
            Seleccionar Medio de Pago
          </DialogTitle>
          <DialogContent>
            <Alert severity="info" sx={{ mb: 2 }}>
              Para marcar el pedido como "Recibido" debe seleccionar un medio de pago.
            </Alert>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Medio de Pago</InputLabel>
              <Select
                value={selectedPaymentMethod}
                onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                label="Medio de Pago"
              >
                {mediosDePago.map((medio) => (
                  <MenuItem key={medio} value={medio}>
                    {medio}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePaymentCancel} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handlePaymentConfirm} variant="contained" color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Notificaciones */}
        <Snackbar
          open={notification.open}
          autoHideDuration={4000}
          onClose={handleCloseNotification}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseNotification}
            severity={notification.severity}
            variant="filled"
            sx={{
              width: "100%",
              "& .MuiAlert-icon": {
                fontSize: "1.5rem",
              },
            }}
            icon={notification.severity === "success" ? <CheckIcon /> : <ErrorIcon />}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </div>
  )
}

// Componente Modal de detalles
function OrderDetailModal({ open, onClose, order, onStatusChange, canChangeToState }) {
  const handleStatusChange = (newStatus) => {
    onStatusChange(order.id, newStatus)
  }

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: open ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1300,
        }}
        onClick={onClose}
      >
        <Paper
          sx={{
            width: "90%",
            maxWidth: "800px",
            maxHeight: "90%",
            overflow: "auto",
            p: 3,
            borderRadius: 3,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <Typography variant="h5" fontWeight="bold">
              Detalles del Pedido #{order.id}
            </Typography>
            <Button onClick={onClose} variant="outlined" size="small">
              Cerrar
            </Button>
          </Box>

          {/* Información del cliente */}
          <Paper sx={{ p: 2, mb: 2, bgcolor: "#f8f9fa" }}>
            <Typography variant="h6" gutterBottom>
              Información del Cliente
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Cliente
                </Typography>
                <Typography variant="body1" fontWeight="500">
                  {order.descripcionEntidad} {order.apellido}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  DNI/CUIT
                </Typography>
                <Typography variant="body1">{order.dniCuitCuil}</Typography>
              </Box>
              <Box sx={{ gridColumn: "1 / -1" }}>
                <Typography variant="body2" color="text.secondary">
                  Dirección
                </Typography>
                <Typography variant="body1">{order.direccion}</Typography>
              </Box>
            </Box>
          </Paper>

          {/* Estado del pedido */}
          <Paper sx={{ p: 2, mb: 2, bgcolor: "#f8f9fa" }}>
            <Typography variant="h6" gutterBottom>
              Estado del Pedido
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Typography variant="body2">Estado actual:</Typography>
              <Chip
                icon={React.createElement(estadoConfig[order.estado].icon, { fontSize: "small" })}
                label={estadoConfig[order.estado].label}
                sx={{
                  bgcolor: estadoConfig[order.estado].bgColor,
                  color: estadoConfig[order.estado].color,
                  fontWeight: "bold",
                }}
              />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Flujo: Pendiente → Recibido → Despachado → Entregado
            </Typography>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              {Object.entries(estadoConfig).map(([estado, config]) => {
                const isCurrentState = order.estado === estado
                const canChange = canChangeToState(order.estado, estado)
                const isDisabled = !isCurrentState && !canChange

                return (
                  <Button
                    key={estado}
                    variant={isCurrentState ? "contained" : "outlined"}
                    size="small"
                    onClick={() => !isDisabled && handleStatusChange(estado)}
                    startIcon={React.createElement(config.icon, { fontSize: "small" })}
                    disabled={isDisabled}
                    sx={{
                      color: isDisabled ? "#ccc" : config.color,
                      borderColor: isDisabled ? "#ccc" : config.color,
                      "&:hover": {
                        bgcolor: isDisabled ? "transparent" : config.bgColor,
                      },
                      ...(isCurrentState && {
                        bgcolor: config.color,
                        color: "white",
                      }),
                    }}
                  >
                    {config.label}
                  </Button>
                )
              })}
            </Box>
          </Paper>

          {/* Información de venta */}
          <Paper sx={{ p: 2, mb: 2, bgcolor: "#f8f9fa" }}>
            <Typography variant="h6" gutterBottom>
              Información de Venta
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2 }}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Fecha
                </Typography>
                <Typography variant="body1">{order.createdAt}</Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Vendedor
                </Typography>
                <Typography variant="body1">{order.usuario}</Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Ubicación
                </Typography>
                <Typography variant="body1">{order.ubicacion}</Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Medio de Pago
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: order.medioPago === "Sin definir" ? "#FF9800" : "inherit",
                    fontWeight: order.medioPago === "Sin definir" ? "bold" : "normal",
                  }}
                >
                  {order.medioPago}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Monto Total
                </Typography>
                <Typography variant="h6" color="success.main" fontWeight="bold">
                  ${order.montoTotal.toLocaleString("es-AR")}
                </Typography>
              </Box>
            </Box>
          </Paper>

          {/* Items del pedido */}
          <Paper sx={{ p: 2, bgcolor: "#f8f9fa" }}>
            <Typography variant="h6" gutterBottom>
              Items del Pedido
            </Typography>
            <Box sx={{ overflow: "auto" }}>
              {order.items.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 2fr 1fr 1fr 1fr",
                    gap: 2,
                    p: 1,
                    borderBottom: index < order.items.length - 1 ? "1px solid #ddd" : "none",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body2" fontFamily="monospace">
                    {item.codigo}
                  </Typography>
                  <Typography variant="body2">{item.descripcion}</Typography>
                  <Typography variant="body2" textAlign="center">
                    {item.cantidad}
                  </Typography>
                  <Typography variant="body2" textAlign="right">
                    ${item.precio.toLocaleString("es-AR")}
                  </Typography>
                  <Typography variant="body2" textAlign="right" fontWeight="bold">
                    ${(item.cantidad * item.precio).toLocaleString("es-AR")}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Paper>
      </div>
    </ThemeProvider>
  )
}
